import { jsx } from 'react/jsx-runtime';
import classnames from '../../../../node_modules/classnames/index.js';
import modules_3d0e1832 from './Body.module.scss.js';

const Body = ({ children, className }) => {
    return (jsx("section", { className: classnames(modules_3d0e1832.body, className), children: children }));
};

export { Body };
//# sourceMappingURL=Body.js.map
